import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../constant/routeConstant';
import { getDetail, getManagementHistoryList } from '../../../../service/setup/TemperatureCategory/TemperatureCategoryService';
import { useSelector } from "react-redux";
import moment from 'moment';

const useDetailTemperature = () => {
  const { token } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [showDelete, setShowDelete] = useState(false);

  const [userManagementOpen, setUserManagementOpen] = useState(false)
  const [managementHistoryList, setManagementHistoryList] = useState([])

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  }

  const getDetailDataGroup = async () => {
    try {
      const response = await getDetail(token, null, location?.state?.id, dispatch);
      if (response && response.ok) {
        setData(response.data);
        setLoading(false);
      }
    } catch (error) {
      return error;
    }
  }

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  }

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return (moment(timestamp).utc().format('HH:mm'))
  }

  const doGetManagementHistoryList = async (id) => {
    try {
      const response = await getManagementHistoryList(token, null, dispatch, id);
      if (response && response.ok) {
        const data = response.data
        const reorderedData = []

        for (let i = data.length - 1; i >= 0; i--) {
          const element = data[i];
          reorderedData.push(element)
        }

        setManagementHistoryList(reorderedData)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getDetailDataGroup();
    doGetManagementHistoryList(location?.state?.id)
  }, []);

  const handleBack = () => {
    navigate(ROUTES.TEMPERATURE_CATEGORY.LIST)
  }

  const toEdit = () => {
    navigate(ROUTES.TEMPERATURE_CATEGORY.EDIT, { state: { id: location?.state?.id, prevPage: location?.pathname } });
  }

  return {
    data,
    handleBack,
    loading,
    toEdit,
    convertTimestamp,
    convertToTime,
    userManagementOpen,
    setUserManagementOpen,
    managementHistoryList
  }
}

export default useDetailTemperature;